import { useEffect, useRef } from "react";
import { Button } from "antd";
import { HiOutlineBell } from "react-icons/hi";
import { LuPhoneCall } from "react-icons/lu";

const Ringing = ({ incomingChat, onAccept, onMute }) => {
  const bellRef = useRef(null);
  const phoneRef = useRef(null);
  const audioRef = useRef(null);
 
  useEffect(() => {
    // animate bell + phone
    bellRef.current?.classList.add("bell-animate");
    phoneRef.current?.classList.add("phone-vibrate");
 
    // play ringtone
    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch(() => {});
    }

    return () => {
      audioRef.current?.pause();
      phoneRef.current?.classList.remove("phone-vibrate");
      bellRef.current?.classList.remove("bell-animate");
    };
  }, [incomingChat?.id]);

  return (
    <div className="flex justify-between bg-white p-5 items-center border rounded-xl shadow">
      <div className="flex items-center gap-3">
        <div className="bell-wrapper" ref={bellRef} aria-hidden>
          <div className="bell-ring-circle" />
          <HiOutlineBell
            style={{
              padding: 8,
              fontSize: 40,
              background: "#FEF2F2",
              color: "#E7000B",
              borderRadius: 12,
              display: "block",
            }}
          />
        </div>

        <div>
          <p className="p-0 m-0 font-semibold text-base">
            New customer is ringing, first to join will own the chat
          </p>
           <p className="p-0 m-0 text-[#71717B] text-sm">
            {incomingChat?.__ringReason === "transfer"
                ? (
                    <>
                    Chat transferred to you from another agent — <span className="font-medium">{incomingChat?.subject}</span>
                    </>
                )
                : (
                    <>
                    {incomingChat?.customer?.name} — Support request,{" "}
                    <span className="font-medium">{incomingChat?.subject}</span>
                    </>
                )
            }
            </p>

        </div>
      </div>

      <div className="flex gap-3 items-center">
        <Button
          className="rounded-2xl flex items-center gap-2"
          type="primary"
          icon={<span ref={phoneRef}><LuPhoneCall style={{ fontSize: 18 }} /></span>}
          onClick={onAccept}
        >
          Accept
        </Button>

        <Button className="rounded-2xl" onClick={onMute}>
          Move to waiting
        </Button>
      </div>

      <audio
        ref={audioRef}
        src="/sounds/ring.mp3"
        preload="auto"
        loop
      />
    </div>
  );
};

export default Ringing;
